export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}
